export const atLeastOneSpecialCharacter =
  /^(.*?[-~!@#\$%\^&\*\(\)\+_=:;\{\}\[\]\|"`'<>,\.\?\\\/]){1,}.*$/;
